import * as firebase from "firebase/app";
import "firebase/messaging";
const initializedFirebaseApp = firebase.initializeApp({
    // Project Settings => Add Firebase to your web app
    apiKey: "AIzaSyB19Ma7iELSl4bH8H4FWtCTEsDOt1sbx-I",
    authDomain: "werafood-153401.firebaseapp.com",
    databaseURL: "https://werafood-153401.firebaseio.com",
    projectId: "werafood-153401",
    storageBucket: "werafood-153401.appspot.com",
    messagingSenderId: "651770869160",
    appId: "1:651770869160:web:830c658cafeb7929",
});
let messaging = null;
if (firebase.messaging.isSupported()) {
    messaging = initializedFirebaseApp.messaging();
    messaging.usePublicVapidKey(
        "BMf9j5SmHtEOTccUBcV5xl91zvFQ0ij1JQYYbz6ldJonxpaSwZqybjJy7LBTHxmpQUb6rIIVlHToH2ohjVf4R50"
    );
}

export { messaging };
